<template>
  <td>
    <v-menu v-model="menu" bottom right transition="scale-transition" origin="top left"
      :disabled="['done', 'rejected'].includes(item.statusCode) || isReadonly">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" :color="itemObj.getStatusCode().color" v-if="itemObj.getStatusCode()"
          :dark="itemObj.getStatusCode().textColor != 'dark'" x-small block elevation="0" rounded>
          <v-icon small left>{{ itemObj.getStatusCode().icon }}</v-icon>
          {{ itemObj.getStatusCode().text }}
        </v-btn>
        <v-chip pill v-on="on" color="grey lighten-4" v-else>
          -
        </v-chip>
      </template>
      <v-card>
        <v-list>
          <v-list-item @click="setStatusCode(statusCode.value)" v-for="statusCode in getStatusCodes()"
            :key="statusCode.value">
            <div
              :style="'background-color:' + statusCode.color + ';width:8px;height:100%;left:0;top:0;position:absolute;'">
            </div>
            <v-list-item-action>
              <v-icon small>{{ statusCode.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-subtitle>{{ statusCode.text }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </td>
</template>
<script>
export default {
  name: 'eod-column-status-code',
  props: {
    item: Object,
    config: Object,
    extra: Object,
    readonly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      settings: require('./../../classes/settings'),
      menu: false,
      finishDialog: false,
      periodicityTask: false,
      isReadonly: false
    }
  },
  computed: {
    itemObj() {
      return new (this.config.itemObject)(this.item);
    }
  },
  mounted() {
    if (this.readonly || (this.extra && this.extra.readonly)) {
      this.isReadonly = true;
    }
    if (this.$eod.getOrganizationSetting('tasks.periodicity.defaultEnabled')) {
      if (this.$eod.getOrganizationSetting('tasks.periodicity.defaultEnabled').value == true) {
        this.periodicityTask = true;
      }
    }
  },
  methods: {
    getStatusCodes() {
      if (this.extra && this.extra.getStatusCodes) {
        return this.extra.getStatusCodes(this.settings);
      }

      return this.settings.statusCodes;
    },
    setStatusCode(statusCode) {
      if (statusCode != this.item.statusCode) {
        this.changeStatus(statusCode);
      }
    },
    changeStatus(statusCode) {
      let query = null;
      if(this.extra && this.extra.onChange){
        query = this.extra.onChange(this.$eod, this.item, statusCode);
      } else {
        query = this.$eod.save(this.config.detail.objectName, { id: this.item.id, statusCode: statusCode });
      }

      return query.then(() => {
        this.item.statusCode = statusCode;
        this.$emit('changed', statusCode);
      });
    }
  }
}
</script>